/** @module components/universal-filters/mobile-filters-toolbar */
import baustein from "baustein";
import template from "templates/modules/universal_filters/mobile_filters_toolbar.jinja";

/**
 * @constructor
 * @alias module:components/universal-filters/mobile-filters-toolbar
 * @extends module:components/components
 */
export default baustein.register(
    "mobile-filters-toolbar",
    /** @lends module:components/universal-filters/mobile-filters-toolbar.prototype */
    {
        template: template,

        defaultOptions: {
            applyMessage: null,
            showBack: false,
        },

        setupEvents(add) {
            add("click", "[data-cancel-button]", this._onCancelClick);
            add("click", "[data-back-button]", this._onBackClick);
            add("click", "[data-apply-button]", this._onApplyClick);
            add("click", "[data-clear-button]", this._onClearClick);
        },

        getInitialRenderContext() {
            return {
                mobile_filters_toolbar: {
                    back_action: this.options.showBack,
                    pending_filters: 0,
                    apply_message: this.options.applyMessage,
                    apply_detail: null,
                    apply_enabled: false,
                },
            };
        },

        /**
         * Show or hide the back button in place of the Cancel button.
         * @param asBack {boolean} - true if back button enabled, false if cancel
         */
        toggleBackButton(asBack) {
            let context = this.getRenderContext();
            context.mobile_filters_toolbar.back_action = asBack;
            this.setRenderContext(context);
        },

        /**
         * Cancel event is fired, that gets sent to the filters sidebar.
         * @private
         */
        _onCancelClick() {
            this.emit("closeFilters");
        },

        /**
         * Back event fired, that gets sent to the fitlers sidebar.
         * @private
         */
        _onBackClick() {
            this.emit("backFilters");
        },

        /**
         * Apply event fired, that gets sent to the universal filters
         * @private
         */
        _onApplyClick() {
            this.emit("applyFilters");
        },

        /**
         * Clear event fired, that gets sent to the universal filters
         * @private
         */
        _onClearClick() {
            this.emit("clearFilters");
        },

        /**
         * Changes / shows / hides the number shown on the "apply filter" button
         * @param text {string} - the text to show
         * @param enabled {boolean} - whether to show it enabled or not
         */
        updateApplyButton(text, enabled) {
            let context = this.getRenderContext();
            context.mobile_filters_toolbar.apply_detail = text;
            context.mobile_filters_toolbar.apply_enabled = enabled;
            this.setRenderContext(context);
        },
    }
);
